import type categoryId from "./id";
import orderEn from "./order/en";
import productEn from "./product/en";

const categoryEn: typeof categoryId = {
	category: {
		...productEn,
		...orderEn,
	},
};

export default categoryEn;
